import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {GlobalQuestionService} from '../../services/global-question.service';
import {FlowPageDataPerson, FlowPageDataProduct, FlowProduct, QuoteCollation} from '../../models/quote.model';
import {QuestionFlowSessionQuery} from '../../questions/state/question-flow-session.query';
import {Question} from '../../models/underwriter.model';
import {AnimationOptions} from 'ngx-lottie';
import {EntryType, QuestionType, RouterLinks} from '../../constants';
import {FlowPlayerService} from '../../services/flow-player.service';
import {ActivatedRoute, Router} from '@angular/router';
import { QuestionStore } from '../../questions/state/question.store';

declare const $: any;

class EditModalCategories {
  class_id: number;
  class_name: string;
  collations: QuoteCollation[];
}

@Component({
    selector: 'app-summary-edit-modal',
    templateUrl: './summary-edit-modal.component.html',
    styleUrls: ['./summary-edit-modal.component.scss'],
    standalone: false
})
export class SummaryEditModalComponent implements OnInit, OnChanges {

  @ViewChild('editModal') public editModal: any;
  @Input() collation: QuoteCollation;
  @Input() collations: QuoteCollation[] = [];
  @Input() product: FlowPageDataProduct;
  @Output() questionAnswer = new EventEmitter<any>();

  questions: Question[] = [];
  childrenQuestions: Question[] = [];
  sessionDetails: any;
  loading = false;
  loaderOptions: AnimationOptions = {
    path: 'assets/everything-insure-loader.json',
  };
  QuestionType = QuestionType;
  readonly = false;
  products: FlowProduct[] = [];
  person: FlowPageDataPerson;
  categories: EditModalCategories[] = [];
  question: any;
  path = '3';
  platform_fee: any;
  taxes: any;
  isSavingData = false;
  activeItemId = '';
  activeClassId = 0;
  editModalEl = '#edit-modal';
  moreQuestions: any;
  locatons: any = [];
  locationActive = false;
  selectedLocation: any;
  locationData: any;
  constructor(
    public globalQuestionService: GlobalQuestionService,
    private router: Router,
    private flowPlayer: FlowPlayerService,
    private ref: ChangeDetectorRef,
    private questionStore: QuestionStore,
    private questionFlowSessionQuery: QuestionFlowSessionQuery
  ) {
    this.sessionDetails = this.questionFlowSessionQuery.getValue();
  }

  ngOnInit(): void {
    this.globalQuestionService.summaryData.subscribe(x => this.isSavingData = x);
  }
  

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.collation?.currentValue !== changes?.collation?.previousValue) {
      this.collation = changes?.collation?.currentValue;
    }
    if (changes?.collations?.currentValue !== changes?.collations?.previousValue) {
      this.collations = changes?.collations?.currentValue;
      this.collation = this.collations?.find(col => col.class_id === this.activeClassId &&
        col.session_item_id === this.activeItemId &&
        col.entry_type === EntryType.item &&
        col.product_id === this.product?.product_id &&
        col.frequency_id === this.globalQuestionService?.currency?.frequency_id);

    }
    if (changes?.product?.currentValue !== changes?.product?.previousValue) {
      this.product = changes?.product?.currentValue;
    }
    this.setupCategories();
  }

  show(summary?: any): void {
    console.log(summary)
    //this.globalQuestionService.spinner(true);
    this.path = summary?.path;
    this.collation = summary?.collation?.length ? summary?.collation[0] : summary?.collation;
    this.collations = summary?.collations;
    this.product = summary?.product;
    this.person = summary?.person;
    this.locationData = summary?.locations;
    if (summary?.locations) {
      this.locatons = summary?.locations.filter(l => l.cent_aq_question_id === 1230); // this.groupByLocation(summary?.locations);
    }
    
    if (this.collation) {
      this.activeItemId = this.collation?.session_item_id;
      this.activeClassId = this.collation?.class_id;
      this.getResponses(this.collation.class_id, this.collation.session_item_id);
    } else {
      // no item to open on (e.g. Edit on a traffic cop profile entry): the General section
      this.changeClassItem(0);
    }
    this.setupCategories();
    
    if (!($(this.editModalEl).hasClass('show'))) {
      if (+this.product?.is_ei_product === 1) {
        $(this.editModalEl).modal('show');
      } else {
        $(this.editModalEl).modal({
          keyboard: false,
          backdrop: 'static'
        });
      }

      $(this.editModalEl).on('shown.bs.modal', () => {
        setTimeout(() => {
          this.globalQuestionService.initPopoverCustomize();
        }, 1000);
      });
    }
  }
  groupByLocation(items: any[]): { location_name: string, questions: any[] }[] {
  const grouped = items.reduce((acc: { [location: string]: any[] }, item: any) => {
    const location = item.description_1 || 'Unknown';

    if (!acc[location]) {
      acc[location] = [];
    }
    // Remove 'location' key and push rest as a question
    const { description_1: loc, ...questionData } = item;
    const questionWithEdit = { ...questionData, isEdit: true };
    acc[location].push(questionWithEdit);

    return acc;
  }, {});

  // Convert grouped object to array of { location_name, questions }
  return Object.keys(grouped).map(location => ({
    location_name: location,
    questions: grouped[location]
  }));
}


  getResponses(class_id: any, item_id: any): any {
    
    
    this.globalQuestionService.getResponses()
      .subscribe(r => {
        let questions: Question[];
        questions = r;
        
        

        if (questions?.length) {
          this.questions = [];
          this.childrenQuestions = [];
        }
        for (let q of questions) {
          try {
            q.isEdit = true;
          }
          catch (e) {
            //console.log(e)
          }
          
          if (q?.item_id?.toString() === item_id?.toString() && q?.product_class_id?.toString() === class_id?.toString()) {
            if (q?.parent_control) {
              this.childrenQuestions.push(q);
              const parentQuestion = questions.find(x => x?.cent_aq_question_id === q?.parent_control);
              if (parentQuestion && !this.questions?.some(x => x.cent_aq_question_id === parentQuestion?.cent_aq_question_id)) {
                parentQuestion.item_id = item_id;
                this.questions.push(parentQuestion);
              }
            } else {
              if (!this.questions?.some(x => x?.cent_aq_question_id === q?.cent_aq_question_id)) {
                this.questions.push(q);
              }
            }
          }
        }
        //console.log(this.childrenQuestions);
        //this.questionStore.set(this.childrenQuestions);
        this.globalQuestionService.spinner(false);
        this.isSavingData = false;
        if (this.locationActive) this.questions = this.selectedLocation.questions;
        this.ref.detectChanges();
      }, error => {
        this.globalQuestionService.spinner(false);
        this.isSavingData = false;
      });
  }

  getItemChildrenQuestions(question: Question): Question[] {
    return this.childrenQuestions.filter(x => x?.parent_control === question?.cent_aq_question_id);
  }

  questionResponse(event): void {
    if (event?.dependant_flow_id) {
      this.question = event;
      $('#modal-additional').modal('show');
    } else {
      const questionIndex = this.questions?.findIndex(question => question?.cent_aq_question_id === event?.cent_aq_question_id);
      if (questionIndex > -1) {
        this.questions[questionIndex] = event;
        this.globalQuestionService.saveIndividualAnswer(this.questions[questionIndex], this.questions[questionIndex].item_id)
          .subscribe(() => {
            if (!this.isSavingData && +this.product?.is_ei_product === 1) {
              //this.globalQuestionService.spinner(true);
              this.isSavingData = true;
              this.globalQuestionService.setSummaryDataObservable(true);
              this.getResponses(this.collation?.class_id ? this.collation?.class_id : 0, this.collation?.session_item_id ? this.collation?.session_item_id : '0');
            } else {
              this.globalQuestionService.spinner(false);
            }
          });
      }
    }
  }

  changeClassItem(class_id: number, item_id?: string): void {
    console.log(class_id, item_id)
    //this.globalQuestionService.spinner(true);
    if (!item_id) {
      item_id = '0';
    }
    this.activeItemId = item_id;
    this.activeClassId = class_id;
    if (class_id === 0 && item_id === '0') {
      this.collation = null;
    } else {
      this.collation = this.collations.find(c => c.class_id === class_id && c.session_item_id === item_id && c.product_id === this.product?.product_id);
    }
    this.getResponses(class_id, item_id);
    this.locationActive = false;
  }

  save(): void {
    this.globalQuestionService.setSummaryDataObservable(true);
    $('#edit-modal').modal('hide');
    this.locationActive = false;
    // this.sessionDetails = main_session.session;
    // this.question = main_session.question;
    // console.log(this.question);
    // this.questionAnswer.emit(this.question);
    // this.questionStore.setActive(this.question.cent_aq_question_id);
  }

  updateTPQChanges(): void {
    // go to quote-confirm-cover-changes
    this.globalQuestionService.setSummaryDataObservable(true);
    this.globalQuestionService.processTpq()
      .subscribe({
        next: v => {
          $('#edit-modal').modal('hide');
          this.router.navigate([`/${RouterLinks.QuoteConfirmCoverChanges}`]);
        }
      });
  }

  setupCategories(): void {
    this.categories = [];
    if (this.product && this.collations?.length) {
      this.product.price = this.collations.find((p: { entry_type: string, product_id: number, frequency_id: number }) => p?.entry_type === 'premium' && p.frequency_id === this.globalQuestionService?.currency?.frequency_id && p.product_id === this.product?.product_id)?.prem_value;
      this.platform_fee = this.collations.find((p: { entry_type: string, product_id: number }) => p?.entry_type === 'fees_subtotal' && p.product_id === this.product?.product_id);
      this.taxes = this.collations.find((p: { entry_type: string, product_id: number }) => p?.entry_type === 'taxes_subtotal' && p.product_id === this.product?.product_id);
    }
    if (this.collations?.length) {
      for (const c of this.collations) {
        if (c.entry_type === 'product_subtotal' && c.product_id === this.product.product_id) {
          this.product.insurer_rating = [{
            insurer_id: this.product.insurer_id,
            insurer_name: '',
            rating_denom: 0,
            rating_score: 0,
            rating_type: '',
            star_css: '',
            insurer_rating: c.insurer_rating
          }];
        }
        if (!this.categories.some(category => category.class_id === c.class_id) && c.mandatory !== 1) {
          this.categories.push({class_id: c.class_id, class_name: c.class_name, collations: []});
        }
      }
    }
    this.categories.sort((a, b) => a.class_id > b.class_id ? 1 : a.class_id < b.class_id ? -1 : 0);
    for (const item of this.categories) {
      item.collations = [];
      for (const c of this.collations) {
        if (this.globalQuestionService.getCount(item.class_id, this.collations) > 0) {
          if (item.class_id === c.class_id && item.class_name === c.class_name && c.product_id === this.product?.product_id && c.frequency_id === this.globalQuestionService?.currency?.frequency_id) {
            let collation: QuoteCollation;
            collation = c;
            let discountList = c.discounts.split(',');

            for (const d of discountList) {
              const dl = d.split(':');
              if (dl[1]) {
                if (discountList?.length) {
                  discountList = [dl[1]];
                } else {
                  discountList.push(dl[1]);
                }
              }
            }

            if (!item.collations?.length) {
              item.collations = [collation];
            } else {
              item.collations.push(collation);
            }
          }
        } else {
          if (item.class_id === 0) {
            item.class_name = 'General';
          }
        }

      }
    }
  }
  moreFlowDone(event: any): void {
    console.log(event);
    //jQuery('#modal-more-mini-flow').modal('hide');
    $('.modal').modal('hide');
    
  }
  startFlow(): void {
    
    // const main_session = {
    //   session: this.sessionDetails,
    //   question: this.question,
    //   current_page: 'edit_modal',
    // };
    // localStorage.setItem('main_session', JSON.stringify(main_session));

      // console.log(this.question);
      // $('#modal-more-mini-flow').modal('show');
   
    this.globalQuestionService.saveAnswer(this.sessionDetails.session_id, 1073, 0, '0', this.path, 0, '')
      .subscribe(result => {
        $('#edit-modal').modal('hide');
        this.flowPlayer.startFlow(0, this.question.dependant_flow_id, this.sessionDetails.category_id, this.sessionDetails.group_id, this.collation.session_item_id, this.sessionDetails.session_id, this.sessionDetails.css, 0);
      },
        err => {
          console.log(err);
        });
  }
  changeLocation(location: any): void {
    this.selectedLocation = location;
    this.questions =  this.locationData.filter(data => data.location_id === location?.location_id);
    this.locationActive = true;
    this.collation = null;
  }
}

